import PropTypes from 'prop-types';
import React from 'react';
import UserGeneratedTextContainer from './UserGeneratedTextContainer';
import styles from './ContentSection.scss';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

const AuthorInfo = props => {
  const {
    ugc: { created_date, author, location },
  } = props;

  return (
    <p className={styles.contentSectionMeta} data-translate={true}>
      Submitted on{' '}
      <span data-key="created_date">{formatDate(created_date)}</span>
      {Boolean(author) && (
        <span>
          {' '}
          by <UserGeneratedTextContainer data-key="author" text={author} />
        </span>
      )}
      {Boolean(location) && (
        <span>
          {' '}
          from{' '}
          <UserGeneratedTextContainer data-key="location" text={location} />
        </span>
      )}
    </p>
  );
};

AuthorInfo.propTypes = {
  ugc: PropTypes.object.isRequired,
};

function formatDate(isoDateString) {
  return format(parse(isoDateString), 'M/DD/YYYY h:mm A');
}

export default AuthorInfo;



// WEBPACK FOOTER //
// ./src/components/ContentSection/AuthorInfo.js